import SearchDictionaryFormContainer from 'components/SearchDictionaryForm/SearchDictionaryFormContainer'

export default {
  Container: SearchDictionaryFormContainer,
}
